import {put} from 'redux-saga/effects';
import supportFiles from '../supportFiles';

export const clearFilesData = function* clearFilesData() {
    yield put({
        type: supportFiles.actionTypes.STORE_FILES,
        payload: {files: []},
    });
};
